import { myScore } from '../../AboutHelpers.tsx';
import { FormulaAccordion } from './components/FormulaAccordion';
import { ScoreComponentsVisual, ScoreComponent } from './components/ScoreComponentsVisual';

const MY_SCORE_EXAMPLE: ScoreComponent[] = [
  {
    key: 'gencc',
    label: 'GENCC',
    maxWeight: 0.5,
    hex: '#0a104f',
    textHex: '#0a104f',
    sources: [],
  },
  {
    key: 'uniprot',
    label: 'UNIPROT',
    maxWeight: 0.25,
    hex: '#be0080',
    textHex: '#be0080',
    sources: [],
  },
  {
    key: 'clinicaltrials',
    label: 'CLINICALTRIALS',
    maxWeight: 0.25,
    hex: '#B45309',
    textHex: '#B45309',
    sources: [],
  },
];

function AboutMyScore(): React.ReactElement {
  return (
    <div id="MyScore">
      <h3>My Score</h3>
      <p>
        My Score is a customizable metric for Gene–Disease and Variant–Disease Associations. Users choose the
        evidence sources they prefer and assign weights to each selection. DISGENET automatically computes My
        score and ranks associations accordingly. What does it do?
        <ul>
          <li className="bullet-item">Ranks results based on your weighted evidence model</li>
          <li className="bullet-item">
            Filters associations to keep only those supported by your chosen sources
          </li>
          <li className="bullet-item">
            Makes prioritization transparent, reproducible, and aligned with internal standards
          </li>
        </ul>
        For example, you can define My Score based on GENCC, UNIPROT and CLINICALTRIALS with the following
        weight distribution:
      </p>
      <ScoreComponentsVisual
        components={MY_SCORE_EXAMPLE}
        showMaxSymbol={false}
        note="Example with equal distribution. Weights are user-defined and must sum to 1."
      />
      <FormulaAccordion label="View example formula">
        <span>{myScore()}</span>
      </FormulaAccordion>
    </div>
  );
}

export default AboutMyScore;
